import Vue from 'vue'
import Router from 'vue-router'

import headlineRouter from './home/headline'
import opinionRouter from './home/opinion'

import checkinRouter from './other/checkin'

import certificateExpiredRouter from './work/certificateExpired'
import democracyRouter from './work/democracy'
import goodsCretRouter from './other/goodsCret'
import heapShelfHeadRouter from './work/heapShelfHead'
import inspectRouter from './work/inspect'
import marketResearchRouter from './work/marketResearch'
import resumeRouter from './work/resume'
import shelvesDataRouter from './work/shelvesData'
import containerRouter from './work/container'
import priceTagRouter from './work/priceTag'
import workorderRouter from './work/workorder'
import wmsDataRouter from './work/wmsData'
import freshOrderRouter from './freshOrder'
import shelveInfosRouter from './shelveInfos'

// import HelloWorld from '@/pages/HelloWorld'

Vue.use(Router)

let routes = []
routes = routes.concat(
  checkinRouter,
  democracyRouter,
  goodsCretRouter,
  headlineRouter,
  heapShelfHeadRouter,
  inspectRouter,
  opinionRouter,
  certificateExpiredRouter,
  containerRouter,
  marketResearchRouter,
  shelvesDataRouter,
  resumeRouter,
  priceTagRouter,
  workorderRouter,
  wmsDataRouter,
  freshOrderRouter,
  shelveInfosRouter
)

const _import = require('./import-' + process.env.NODE_ENV)
routes = routes.concat(
  [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: _import('HelloWorld')
    // },
    {
      path: '/',
      name: 'Index',
      component: _import('Index'),
      meta: {
        title: '首页',
        keepAlive: true
      }
    },
    {
      path: '/work',
      name: 'work',
      component: _import('work'),
      meta: {
        title: '工作台',
        keepAlive: true
      }
    },
    {
      path: '/Error',
      name: 'Error',
      component: _import('Error'),
      meta: {
        title: '温馨提示'
      }
    },
    {
      path: '/lectureHall/Index',
      name: 'lectureHallIndex',
      component: _import('lectureHall/Index'),
      meta: {
        title: '董事长讲堂',
        keepAlive: true
      }
    },
    {
      path: '/lectureHall/Detail',
      name: 'lectureHallDetail',
      component: _import('lectureHall/Detail'),
      meta: {
        auth: true,
        title: '讲堂详情',
        keepAlive: true
      }
    },
    {
      path: '/deliver/Index',
      name: 'deliverIndex',
      component: _import('deliver/Index'),
      meta: {
        title: '爱的传递',
        keepAlive: true
      }
    },
    {
      path: '/newspaper/detail',
      name: 'newspaperDetail',
      component: _import('newspaper/detail'),
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: '/cardcode/Create',
      name: 'cardcodeCreate',
      component: _import('cardcode/Create'),
      meta: {
        title: '提货预约',
        auth: true
      }
    },
    {
      path: '/cardcode/MyList',
      name: 'cardcodeMyList',
      component: _import('cardcode/MyList'),
      meta: {
        title: '我的预约',
        auth: true
      }
    }
  ]
)
export default new Router({
  mode: 'history',
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js